export function getFileNameFromPath(filePath) {
  return filePath?.split('/').pop();
}
